import AppLayout from "../../components/feature/AppLayout";
import AddChurchWizard from "./components/AddChurchWizard";

export default function AddChurchPage() {
  return (
    <AppLayout>
      <AddChurchWizard />
    </AppLayout>
  );
}
